<template>
  <component
    :is="tag"
    v-if="html"
    v-html="text"
  />
  <component
    :is="tag"
    v-else
  >{{ text }}
  </component>
</template>

<script>
import Vue from 'vue'
import { getTranslation } from './Translation'

export default Vue.extend({
  name: 'TranslationDisplay',
  props: {
    translation: Object,
    html: Boolean,
    tag: {
      type: String,
      default: 'div'
    },
  },
  computed: {
    text () {
      return getTranslation(this.translation)
    },
  }
})
</script>

<style
  scoped
  lang="scss"
>

</style>